import { render, staticRenderFns } from "./EmployeeWageData.vue?vue&type=template&id=46ff3d68&scoped=true&"
import script from "./EmployeeWageData.vue?vue&type=script&lang=js&"
export * from "./EmployeeWageData.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeWageData.vue?vue&type=style&index=0&id=46ff3d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ff3d68",
  null
  
)

export default component.exports